export function resolveAiPillState({ hasAgent, canControl, paused } = {}) {
  if (!hasAgent) return 'hidden';
  if (!canControl) return 'info';
  return paused ? 'paused' : 'active';
}

export function isAiPillPaused(state) {
  return state === 'paused';
}
